import React from "react";
import "./Stack.css"; // Import the CSS for styling

const Stack = ({ children }) => {
  return <div className="stack">{children}</div>;
};

export default Stack;
